import {gql} from "@apollo/client";
import filterDataGql, { executeQueryUtil } from '../utils/gqlUtil';
import apolloClient from "../apolloClient/ApolloClient";

const common = `
    id
    maxtemp_c
    mintemp_c
    avgtemp_c
    maxwind_kph
    avghumidity
    condition
    conditionIcon
    hoursDetail {
        time
        temp_c
        wind_kph
        humidity
        condition
        conditionIcon
    }
`

export const getWeatherByDayQuery = (brandId, establishmentId, day) => {
    var debug = `
    query {
      getWeatherData(brandId: "${brandId}", establishmentId: "${establishmentId}", day:"${day}") {
        ${common}
      }
    }
  `
    console.log(debug);

    return gql`
    query {
      getWeatherData(brandId: "${brandId}", establishmentId: "${establishmentId}", day:"${day}") {
        ${common}
      }
    }
  `;
}





